import c from "./internal/_checkForMethod.mjs";
import t from "./internal/_curry3.mjs";
var p = /* @__PURE__ */ t(
  /* @__PURE__ */ c("slice", function(r, e, o) {
    return Array.prototype.slice.call(o, r, e);
  })
);
export {
  p as default
};
